import React from 'react';
import { createUseStyles } from 'react-jss';
import { message, Button, Card, Form, Checkbox, DatePicker } from 'antd';
import { Action } from 'fennec-ui';

import locale from 'antd/es/date-picker/locale/ru_RU';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import PageLayout from '../../components/PageLayout';
dayjs.locale('ru');
var _ = require('lodash');

export default function FederationadministratorReportsEkvairing(props) {
    const { auth } = props;

    return (
        <PageLayout>
            <Card size="small" style={{ borderLeftWidth: "0px", borderRightWidth: "0px" }}>
                <Action
                    auth={auth}
                    action={(values, unlock, close) => {
                        if (!!values.showdisplay) {
                            close();
                            var a = document.createElement("a");
                            document.body.appendChild(a);
                            a.style = "display: none";
                            return function (data, name, type) {
                                a.href = `/api/report/ekvairing/upload-control?showdisplay=true`;
                                a.target = "_blank"
                                a.click();
                                a.remove();
                            };
                        } else {
                            auth.fetchFile(`/api/report/ekvairing/upload-control?showdisplay=false`)
                                .then(async (res) => {
                                    close();
                                });
                        }
                    }}
                    modal={{
                        title: "Контроль загруженных данных"
                    }}
                    okText="Построить отчет"
                    mode={"func"}
                    form={(props) => {
                        const { auth, form, submit } = props;
                        return (
                            <Form
                                form={form}
                                onFinish={submit}
                                labelAlign={"left"}
                                layout={"vertical"}
                                initialValues={{
                                    showdisplay: false
                                }}
                            >
                                <Form.Item name="showdisplay" valuePropName="checked">
                                    <Checkbox>
                                        Вывести на экран
                                    </Checkbox>
                                </Form.Item>
                            </Form>
                        )
                    }}
                    trigger={(click) => (
                        <div>
                            <Button type="link" onClick={click}>Контроль загруженных данных</Button>
                        </div>
                    )}
                />
                <Action
                    auth={auth}
                    action={(values, unlock, close) => {
                        var datestart = dayjs(values.datestart).format("YYYY-MM-DD")
                        var dateend = dayjs(values.dateend).format("YYYY-MM-DD")

                        if (!!values.showdisplay) {
                            close();
                            var a = document.createElement("a");
                            document.body.appendChild(a);
                            a.style = "display: none";
                            return function (data, name, type) {
                                a.href = `/api/report/ekvairing/r1?showdisplay=true&datestart=${datestart}&dateend=${dateend}`;
                                a.target = "_blank"
                                a.click();
                                a.remove();
                            };
                        } else {
                            auth.fetchFile(`/api/report/ekvairing/r1?showdisplay=false&datestart=${datestart}&dateend=${dateend}`)
                                .then(async (res) => {
                                    close();
                                });
                        }
                    }}
                    modal={{
                        title: "Сверка эквайринга"
                    }}
                    okText="Построить отчет"
                    mode={"func"}
                    form={(props) => {
                        const { auth, form, submit } = props;
                        return (
                            <Form
                                form={form}
                                onFinish={submit}
                                labelAlign={"left"}
                                layout={"vertical"}
                                initialValues={{
                                    showdisplay: false
                                }}
                            >
                                <Form.Item
                                    label={"Дата начала"}
                                    name={"datestart"}
                                    rules={[{ required: true, message: 'Пожалуйста, укажите дату начала!' }]}
                                >
                                    <DatePicker style={{ width: "100%" }} suffixIcon={<></>} format="YYYY-MM-DD" locale={locale} />
                                </Form.Item>

                                <Form.Item
                                    label={"Дата окончания"}
                                    name={"dateend"}
                                    rules={[{ required: true, message: 'Пожалуйста, укажите дату окончания!' }]}
                                >
                                    <DatePicker style={{ width: "100%" }} suffixIcon={<></>} format="YYYY-MM-DD" locale={locale} />
                                </Form.Item>

                                <Form.Item name="showdisplay" valuePropName="checked">
                                    <Checkbox>
                                        Вывести на экран
                                    </Checkbox>
                                </Form.Item>
                            </Form>
                        )
                    }}
                    trigger={(click) => (
                        <div>
                            <Button type="link" onClick={click}>Сверка эквайринга</Button>
                        </div>
                    )}
                />
            </Card>
        </PageLayout>
    );
}
